<template>
  <button class="w-max flex items-center gap-1 pl-2.5 pr-2 py-1.5 rounded-lg border border-border-normal transition-colors duration-100 hover:border-border-hover"
  @click="copyLink">
    <div ref="linkContainer" class="relative" :style="{ width: linkWidth }">
      <transition>
        <BaseText v-if="!isCopied" type="label" size="sm" class="text-text-muted" key="link-text">
          {{ link }}
        </BaseText>
        <BaseText v-else type="label" size="sm" class="text-text-normal" key="copied-text">
          Copied!
        </BaseText>
      </transition>
    </div>
    <div class="relative w-5 h-5 flex-shrink-0">
      <transition>
        <svg v-if="!isCopied" class="text-icon-normal" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M7.75 7.75V4.1875C7.75 3.66973 8.16973 3.25 8.6875 3.25H15.8125C16.3303 3.25 16.75 3.66973 16.75 4.1875V11.3125C16.75 11.8303 16.3303 12.25 15.8125 12.25H12.25M11.3125 7.75H4.1875C3.66973 7.75 3.25 8.16973 3.25 8.6875V15.8125C3.25 16.3303 3.66973 16.75 4.1875 16.75H11.3125C11.8303 16.75 12.25 16.3303 12.25 15.8125V8.6875C12.25 8.16973 11.8303 7.75 11.3125 7.75Z" 
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <CheckmarkIcon v-else class="text-icon-normal" />
      </transition>
    </div>
  </button>
</template>

<script>
import { copyTextAsync } from '@/utils/clipboard'
import CheckmarkIcon from '../../globals/Icons/NewCheckmarkIcon.vue'

export default {
  name: 'CopiableLink',
  components: {
    CheckmarkIcon
  },
  props: {
    link: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isCopied: false,
      linkWidth: 'auto',
      resetTimeoutId: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      const linkContainer = this.$refs.linkContainer
      const linkRect = linkContainer.getBoundingClientRect()
      this.linkWidth = `${linkRect.width}px`
    })
  },
  beforeDestroy () {
    if (this.resetTimeoutId) clearTimeout(this.resetTimeoutId)
  },
  methods: {
    async copyLink () {
      if (this.isCopied) return
      try {
        await copyTextAsync(this.link)
        this.isCopied = true
        if (this.resetTimeoutId) clearTimeout(this.resetTimeoutId)
        this.resetTimeoutId = setTimeout(() => { this.isCopied = false }, 2500)
      } catch (err) {
        this.$showAlert({ type: 'error', message: 'Unable to copy to clipboard' })
      }
    }
  }
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-leave-active {
  position: absolute;
  inset: 0;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>